/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import 'simplebar';
import './lib/jquery.hoverIntent.min';
import 'jquery-nice-select';
import SwiperSlider from './components/SwiperSlider';
import './lib/i18n/jquery.ui.datepicker-pl';
import './lib/jquery.ui.zIndex';
import './lib/jquery.ui.datepicker.min';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';
import HomePageModule from './modules/HomePageModule';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
import lazysizes from 'lazysizes';
import dev from './dev';

if (typeof DEV_MODE !== 'undefined' && DEV_MODE) {
  dev.init();
}


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const form = new Form();
  const swiperSlider = new SwiperSlider();
  let topMenuEl = $('#_desktop_top_menu #top-menu');
  let topMenu = new TopMenu(topMenuEl);
  $('select').niceSelect();

  form.init();

  swiperSlider.init('#carousel', {
    youtube: true,
    watchSlidesVisibility: true,
    preloadImages: true,
    lazy: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">0' + (index + 1) + '</span>';
      },
    },
  });

  swiperSlider.init('#js-homepage-boxes-after-slide', {
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 2000,
    }
  });

  swiperSlider.init('.js-special-products-slider', {
    navigation: {
      nextEl: '.js-special-products-button-next',
      prevEl: '.js-special-products-button-prev'
    },
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 30
      }
    }
  });

  swiperSlider.init('.js-new-products-slider', {
    navigation: {
      nextEl: '.js-news-products-button-next',
      prevEl: '.js-news-products-button-prev'
    },
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 30
      }
    }
  });

  swiperSlider.init('.js-products-slider', {
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 30
      }
    }
  });

  swiperSlider.init('.js-manufacturers-slider', {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.js-manufacturers-button-next',
      prevEl: '.js-manufacturers-button-prev'
    },
    breakpoints: {
      1200: {
        slidesPerView: 5,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 15
      }
    }
  });

  topMenu.init();

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
  });

  //ps_category_tree - show active category-tree
  $('.active_category_tree').parents('.collapse').addClass('show').parent().children('.collapse-icons').attr('aria-expanded', 'true');

  $('.js-date-picker').datepicker({
      setDefaults : $.datepicker.regional[ "pl" ],
      dateFormat: 'yy-mm-dd',
      beforeShow : function(){
          if(!$('.datepicker_wrapper').length){
              $('#ui-datepicker-div').wrap('<div class="custom-datepicker"></div>');
          }
      }
  });
    const scrollItems = $('#scrollbar-tracker .scrollbar-tracker-item').map(function () {
        let item = $($(this));
        if (item.length) {
            return item;
        }
    });

    $(window).scroll(function () {

        let fromTop = $(this).scrollTop() + $('#header').outerHeight() + 200;

        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop) {
                $(this).addClass('scrolled');
                return this;
            } else {
                $(this).removeClass('scrolled');
            }
        });
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        $('.scrollbar-tracker-item').removeClass('active');
        $('[id="' + id + '"]').removeClass('scrolled').addClass('active');
    });

    if (prestashop.page.page_name === 'index') {
      const homePageModule = new HomePageModule();
    }
});
document.addEventListener('lazyloaded', function(e){
    $(e.target).parent().addClass('rc--lazyload');
});
